module.exports = __webpack_public_path__ + "media/images/common/update_btn_l_ov-373ff55a0cfd15f778918cf644e1acc6.png";